(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1937],{

/***/ 11937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget086": function() { return /* binding */ LayoutWidget086; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47696);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65202);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63414);
/* harmony import */ var _LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73648);
/* harmony import */ var _LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var LayoutWidget086 = function(param) {
    var payload = param.payload;
    var ref;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_1__/* .buildWidgetInstanceId */ .G1)("l086", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_2__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var articles = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_6__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "articles",
            defaultValue: []
        }, 
    ]).articles;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var _articles = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(articles, 1), article = _articles[0];
    var articleDate = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return (0,shared_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(article === null || article === void 0 ? void 0 : article.date, locale);
    }, [
        article === null || article === void 0 ? void 0 : article.date,
        locale
    ]);
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tags),
                        children: (ref = article.articleCategories) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var id = param.id, title = param.title;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                color: "dark",
                                appearance: "smaller",
                                className: (_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tag),
                                uppercase: true,
                                children: title
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                        color: "grey",
                        className: (_LayoutWidget086_module_scss__WEBPACK_IMPORTED_MODULE_9___default().date),
                        uppercase: true,
                        children: articleDate
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget086);


/***/ }),

/***/ 73648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget086_wrapper__333m2","inner":"LayoutWidget086_inner__4gIh6","tags":"LayoutWidget086_tags__fYZz_","tag":"LayoutWidget086_tag__87X3C","date":"LayoutWidget086_date__Lztvq"};

/***/ })

}]);